import React from 'react';
import { ErrorMessage } from 'formik';
import { ErrMsgProps } from "../models/App";

/**
 * Custom implementation of Formik's ErrorMessage to improve accessibility.
 * Allows us to pass an ID to the rendered element displaying the error message.
 * This ID can be referenced by the companion Input's aria-describedby attribute.
 * @param {ErrMsgProps} props - incoming props
 * @param {string} props.id - a unique ID on the rendered error message.  used in the companion Input's aria-describedby attr
 * @param {string} props.name - the Formik field name containing the error message to render
 * @param {string} props.className - optional prop adding add'l classes to the rendered error
 * @component
 */
function CustomErrorMsg({id, name, className}: ErrMsgProps) {
  return (
    <ErrorMessage
    name={name}
  >{errMsg => <div id={id} className={`form-validation input-feedback ${className ?? ""}`}>{errMsg}</div>}
  </ErrorMessage>
  )
}
export default CustomErrorMsg
